import * as React from 'react';
import * as ReactDOM from 'react-dom';

import diyLightTheme = require("../../material-ui/diyLightTheme");
import { colors } from "material-ui/styles";

import ActionBarToolbar from "./ActionBarToolbar";
import ActionBarOptions from "../interfaces/ActionBarOptions";
import { autoprefixer } from "../../material-ui/autoprefixer";
import Paper from 'material-ui/Paper';

import { IOSFixFixed } from '../../components/IOSFixFixed';

import { watchSize } from '../../util/watchSize';
import { animatedScrollByY } from '../../util/animatedScroll';
import { makeTopSpace, getTopSpace } from '../../util/page';

export interface ActionBarProps extends React.Props<ActionBar>, ActionBarOptions {
    open?: boolean;
    elementId?: string;
    undoEnabled?: boolean;
    redoEnabled?: boolean;
}

export default class ActionBar extends React.Component<ActionBarProps, {}> {
    static defaultProps = {
        hasFeedbackbutton: false
    };
    static childContextTypes: React.ValidationMap<any> = {
        muiTheme: React.PropTypes.object
    };

    private content: HTMLElement;
    private actionBarSizeUnwatch: () => void;
    private topSpaceWhenClosed: number;

    getChildContext() {
        return {
            muiTheme: diyLightTheme
        };
    }

    getStyles() {
        return {
            root: autoprefixer({
                position: "fixed",
                zIndex: 101000, // `#diyToolbar` is 100111
                top: 0,
                left: 0,
                right: 0,
                transform: `translate3d(0, ${this.props.open ? 0 : -100}%, 0)`,
                transition: "transform .6s ease-in-out"
            }),
            gradient: {
                left: 0,
                bottom: '-70px',
                position: 'absolute',
                pointerEvents: 'none',
                height: '70px',
                width: '100%',
                opacity: this.props.open ? 1 : 0,
                transition: 'opacity .6s ease-in-out',
                background: 'linear-gradient(to top, ' +
                    'rgba(0, 0, 0, 0) 0%, ' +
                    'rgba(0, 0, 0, 0.01) 40%, ' +
                    'rgba(0, 0, 0, 0.05) 70%, ' +
                    'rgba(0, 0, 0, 0.15) 88%, ' +
                    'rgba(0, 0, 0, 0.3) 100%' +
                    ')'
            },
            content: {
                position: "relative",
                zIndex: 1,
                background: colors.white,
                padding: "4px 8px"
            }
        };
    }

    componentDidUpdate(prevProps: ActionBarProps) {
        const TOOLBAR_HEIGHT = 56;
        const CONTENT_HEIGHT = 56;
        const ACTIONBAR_MIN_HEIGHT = TOOLBAR_HEIGHT + CONTENT_HEIGHT;

        if (prevProps.open !== this.props.open) {
            const handleHeightChange = (height: number) => {
                makeTopSpace(Math.max(height, ACTIONBAR_MIN_HEIGHT), true);
            };

            if (this.props.open) {
                this.topSpaceWhenClosed = getTopSpace();
                let actionBarEl = ReactDOM.findDOMNode(this) as HTMLElement;
                this.actionBarSizeUnwatch = watchSize(actionBarEl, (w, h) => {
                    handleHeightChange(h);
                });
                handleHeightChange(actionBarEl.offsetHeight);
            } else {
                this.actionBarSizeUnwatch();
                makeTopSpace(this.topSpaceWhenClosed, true);
            }
        }

        if (this.props.open && !this.props.autoScrollElement) {
            return;
        }

        let newHeight = 0;
        let actionBarRect: ClientRect;
        if (this.props.open) {
            actionBarRect = ReactDOM.findDOMNode(this).getBoundingClientRect();
            newHeight = actionBarRect.height;
        }

        if (prevProps.open !== this.props.open) {
            this.autoScroll();
        }

        if (this.props.currentTab !== prevProps.currentTab) {
            this.content.style.transition = "";
            this.content.style.opacity = "0";
            setTimeout(() => {
                this.content.style.transition = "all 0.5s";
                this.content.style.opacity = "1";
            }, 0);
        }
    }

    render() {
        let styles = this.getStyles();

        const content = this.props.tabs
          ? this.props.tabs[this.props.currentTab].content
          : this.props.children;

        return (
            <IOSFixFixed>
                <Paper style={styles.root} id={this.props.elementId}>
                    <ActionBarToolbar
                        titleText={this.props.titleText}
                        onHelpClick={this.props.onHelpClick}
                        onUndoClick={this.props.onUndoClick}
                        onRedoClick={this.props.onRedoClick}
                        buttons={this.props.buttons}
                        undoEnabled={this.props.undoEnabled}
                        redoEnabled={this.props.redoEnabled}
                        tabs={this.props.tabs}
                        currentTab={this.props.currentTab}
                        onTabChange={this.props.onTabChange}
                        hasFeedbackbutton={this.props.hasFeedbackbutton}
                        feedbackContext={this.props.feedbackContext}
                        onFeedbackSubmit={this.props.onFeedbackSubmit}
                    />
                    <div style={styles.content}>
                        <div ref={(ref) => this.content = ref}>
                            {content}
                        </div>
                    </div>
                    <div style={styles.gradient} />
                </Paper>
            </IOSFixFixed>
        );
    }

    private autoScroll() {
        const AUTO_SCROLL_DURATION = 500; // ms
        const AUTO_SCROLL_TOP_OFFSET = 50; // px

        const actionBarRect = ReactDOM.findDOMNode(this).getBoundingClientRect();

        if (this.props.autoScrollElement) {
            const autoScrollElementRect: ClientRect = this.props.autoScrollElement.getBoundingClientRect();
            const scrollDelta: number = actionBarRect.height + AUTO_SCROLL_TOP_OFFSET - autoScrollElementRect.top;
            if (scrollDelta > 0) {
                animatedScrollByY(-scrollDelta, AUTO_SCROLL_DURATION);
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/actionBar/components/ActionBar.tsx
 **/